// extracted by mini-css-extract-plugin
export var tosLink = "_ah-0";